import { createAction, props } from '@ngrx/store';

import { CommonIdPlaylist } from '../../models/common-id/common-id-playlist';
import {
  SciencePlaylistProblem,
  EnglishPlaylistProblem,
  NationalLanguagePlaylistProblem,
  HistoryPlaylistProblem
} from '../../models/problem';

// findPlaylists ------------------------------------------------------------
export const findPlaylists = createAction('[CommnIdPlaylist] Find Common Id Play Lists');
export const findPlaylistsSuccess = createAction(
  '[CommnIdPlaylist] Find Common Id Play Lists Success',
  props<{ playlists: CommonIdPlaylist[] }>()
);
export const findPlaylistsFailure = createAction('[CommnIdPlaylist] Find Common Id Play Lists Failure');

// findPlaylistProblemIds ------------------------------------------------------------
export const findPlaylistProblemIds = createAction(
  '[CommnIdPlaylist] Find Common Id English Playlist Problem Ids',
  props<{ subjectId: string; playlistId: string }>()
);

export const findPlaylistProblemIdsSuccess = createAction(
  '[CommnIdPlaylist] Find Common Id Playlist Problem Ids Success',
  props<{ playlistProblemIds: string[] }>()
);
export const findPlaylistProblemIdsFailure = createAction('[CommnIdPlaylist] Find Common Id Playlist Problem Ids Failure');
export const initializePlaylistProblemIdsState = createAction('[CommnIdPlaylist] Initialize Common Id Playlist Problem Ids State');

// findPlaylistProblems ------------------------------------------------------------
export const findPlaylistProblems = createAction(
  '[CommnIdPlaylist] Find Common Id Playlist Problems',
  props<{ subjectId: string; playlistId: string }>()
);
export const findPlaylistProblemsSuccess = createAction(
  '[CommnIdPlaylist] Find Common Id Playlist Problems Success',
  props<{
    subjectId: string;
    playlistProblems: EnglishPlaylistProblem[] | SciencePlaylistProblem[] | NationalLanguagePlaylistProblem[] | HistoryPlaylistProblem[];
  }>()
);
export const findPlaylistProblemsFailure = createAction('[CommnIdPlaylist] Find Common Id Playlist Problems Failure');
export const initializePlaylistProblemsState = createAction('[CommnIdPlaylist] Initialize Common Id Playlist Problems State');

// findPdfUrl ------------------------------------------------------------
export const resolvePdfObjectUrl = createAction('[CommnIdPlaylist] Resolve Common Id Pdf Object Url', props<{ pdfPath: string }>());
export const resolvePdfObjectUrlSuccess = createAction(
  '[CommnIdPlaylist] Resolve Common Id Pdf Object Url Success',
  props<{ pdfPath: string; objectUrl: string }>()
);
export const resolvePdfObjectUrlFailure = createAction('[CommnIdPlaylist] Resolve Pdf Object Url Failure', props<{ pdfPath: string }>());
export const initializePdfObjectUrl = createAction('[CommnIdPlaylist] Initialize Pdf Object Url', props<{ pdfPath: string }>());
export const initializePdfObjectUrlState = createAction('[CommnIdPlaylist] Initialize Pdf Object Url State');
